import React, { useMemo, useCallback } from 'react'
import _ from 'lodash'

import {
  Modal,
  Input,
  Checkbox,
} from  '../../../components'

import useModel from '../../../common/useModel'

import required from '../../../common/validators/required'


import S from './copyVariationModalStyled.js'

const defaultModel = {
  values: {
    translates: {},
    copy: false,
    selected: null,
  },
}

const CopyVariationModal = ({ variations, locales, onChange, onClose, defaultLocale, field }) => {

  const { text, checkbox, model, isValid, values, onChange: changeModel } = useModel(defaultModel)

  const handleConfirm = useCallback(() => {
    onChange({
      translates: Reflect.ownKeys(values.translates).reduce((acc, locale) => ({
        ...acc,
        [locale]: { [field]: values.translates[locale] },
      }), {}),
      ...(values.copy ? ({
        variation: variations[values.selected],
      }): null),
      variationIndex: values.selected,
    })
  }, [field, onChange, values.copy, values.selected, values.translates, variations])


  const actions = useMemo(() => {
    return [{
      title: 'Cancel',
      action: onClose,
      blue: true,
      outlined: true,
    }, {
      title: 'Confirm',
      action: handleConfirm,
      blue: true,
      disabled: !isValid || (values.copy && values.selected === null),
    }]
  }, [onClose, handleConfirm, isValid, values.copy, values.selected])

  return (
    <Modal isOpened actions={actions} padding={'10px 20px'} flexRow>
      <S.ModalContent>
        <S.Title>New Variation</S.Title>
        <S.Translates>
          {
            locales.map((locale, index) => (
              <div key={`locale_${index}`}>
                <Input {...{
                  name: `values.translates.${locale.id}`,
                  text,
                  title: locale.name,
                  warnEmpty: true,
                  rows: 10,
                  validate: locale.id === defaultLocale ? required : null,
                  error: locale.id === defaultLocale ?
                    _.get(model, `errors.values.${defaultLocale}${field}`) : null,
                  autoFocus: index === 0,
                }}
                />
              </div>
            ))
          }
        </S.Translates>

        <div style={{ marginTop: 20 }}/>
        <Checkbox {...checkbox({
          name: 'values.copy',
          title: 'Copy existing variation',
        })}/>

        {
          values.copy && <S.Existing className={!values.copy ? 'disabled' : ''}>
            {
              variations.map((variation, index) => (
                <S.ExistingItem
                  key={`variation_${index}`} className={values.selected === index ? 'selected' : null}
                  onClick={() => changeModel({ target: {
                    name: 'values.selected',
                    value: index,
                  } })}
                >
                  {variation.translates[defaultLocale].variant}
                </S.ExistingItem>
              ))
            }
          </S.Existing>
        }

      </S.ModalContent>
    </Modal>
  )
}

export default CopyVariationModal
